const icon = "_icon_1ye7b_27";
const spin = "_spin_1ye7b_1";
const styles = {
  icon,
  spin
};
export {
  styles as default,
  icon,
  spin
};
//# sourceMappingURL=InlineSpinner.module.css.js.map
